module.exports = __webpack_public_path__ + "static/beauty-creative-team-section-code-e0f8e83b28422894f7631effca707670.png";